import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { useAuthContext } from './whitaijiFrontendLibrary/auth/hooks/useAuthContext'
import { AuthContext } from './context/AuthContext' //AuthContext from './context/AuthContext'
import ProtectedRoute from './whitaijiFrontendLibrary/auth/components/ProtectedRoute'
import ScreenLogger from './components/ScreenLogger'

// pages & components
import Footer from './components/Footer'
import Home from './pages/Home'
import Login from './pages/Login'
import Signup from './pages/Signup'
import Navbar from './components/Navbar'
import AiBot from './pages/AiBot'
import DocTests from './pages/DocTests'
import Unsubscribe from './pages/Unsubscribe'
import Dashboard from './pages/Dashboard'
import AboutMe from './pages/AboutMe'
import HowItWorks from './pages/HowItWorks'
import AnxietyWhatIf from './pages/anxiety-what-if'
import TellMeHowYouFeel from './pages/TellMeHowYouFeel'
import BookWriting from './pages/BookWriting'
import AiAudioAnalysis from './pages/AiAudioAnalysis'
import LoginRedirect from './components/LoginRedirect'
import Emails from './pages/Emails'
import BuildSurvey from './pages/BuildSurvey'
import SurveyReport from './pages/SurveyReport'
import Survey from './pages/Survey'
import MakeConcertPage from './pages/MakeConcertPage'
import ManageSongs from './pages/ManageSongs'
import Concert from './pages/Concert'
import QStashTest from './pages/QStashTest'
import ChangePassword from './pages/ChangePassword'
import { useState } from 'react'
import { useStateContext } from './context/StateContext'
import Loading from './whitaijiFrontendLibrary/components/Loading'
import InviteClient from './pages/InviteClient'
import Profile from './pages/Profile'
import Feedback from './pages/Feedback'
import MyJournal from './pages/MyJournal'
import JournalEntry from './pages/JournalEntry'
import LogsReport from './pages/LogsReport'
import Crm from './pages/Crm'
import Webinar from './pages/landingPages/Webinar'
import CreateCampaign from './pages/CreateCampaign'
import VisDiv from './components/VisDiv'

function App() {
  const { user } = useAuthContext(AuthContext)
  const { apiUrl, language, setLanguage } = useStateContext()
  const userLanguage = user?.language
  const browserLanguage = navigator.language
  const urlParams = new URLSearchParams(window.location.search);
  const hideHeader = urlParams.get('hideHeader');
  const hideFooter = urlParams.get('hideFooter');
  //const location = useLocation();

  useEffect(() => {
   // process.env.NODE_ENV === "development" && console.log("userLanguage", userLanguage, browserLanguage)
    if(!user?.language) {
      if(browserLanguage === "it-IT" || browserLanguage === "it" || browserLanguage === "it-CH"){
        setLanguage("it")
      } else {
        setLanguage("en")
      }
    }
    if(user?.language){
      setLanguage(user.language)
    }
    if (!user?.language && !browserLanguage) {
      setLanguage("en")
    }
  }, [userLanguage])

  if(!language || !apiUrl) return <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100vh"}}><Loading/></div> 

  // Redirection for change password is now handled in the ProtectedRoute component
  return (
    <div className="App">
      <BrowserRouter future={{ v7_startTransition: true }}>
{/*         <div style={{position:"fixed", bottom:0, width:"100%", zIndex: 999}}>
          <ScreenLogger />
        </div> */}
        <VisDiv rules={[hideHeader !== "true"]}>
          <Navbar />
        </VisDiv>
     
        <div className="pages">
          <Routes>
{/*             <Route 
              path="/" 
              element={user ? (
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              ) : <Home />} 
            /> */}
            <Route 
              path="/" 
              element={!user ? <Home /> : 
              <ProtectedRoute>
               <MakeConcertPage />
              </ProtectedRoute>
              } 
            />
            <Route 
              path="/login" 
              element={!user ? <Login AuthContext={AuthContext}/> : <LoginRedirect />} 
            />
            <Route 
              path="/signup" 
              element={!user ? <Signup AuthContext={AuthContext} /> : <Navigate to="/" />} 
            />
            <Route 
              path="/signup_user" 
             
              element={
                <ProtectedRoute>
                  <Signup AuthContext={AuthContext} />
                </ProtectedRoute>} 
            />
            <Route 
              path="/change-password" 
              element={
                <ProtectedRoute>
                  <ChangePassword AuthContext={AuthContext} />
                </ProtectedRoute>} 
            />
            <Route 
              path="/aibot" 
              element={
                <ProtectedRoute>
                  <AiBot AuthContext={AuthContext} />
                </ProtectedRoute>
              } 
            />
            
            <Route 
              path="/invite-client" 
              element={
                <ProtectedRoute>
                  <InviteClient AuthContext={AuthContext} />
                </ProtectedRoute>
              } 
            />
      
            <Route 
              path="/build-survey" 
              element={
                <ProtectedRoute>
                  <BuildSurvey AuthContext={AuthContext} />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/feedback" 
              element={
                <ProtectedRoute>
                  <Feedback AuthContext={AuthContext} />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/my-journal" 
              element={
                //<ProtectedRoute>
                  <MyJournal AuthContext={AuthContext} />
               // </ProtectedRoute>
              } 
            />
            <Route 
              path="/my-journal/journalEntry" 
              element={
                //<ProtectedRoute>
                  <JournalEntry AuthContext={AuthContext} />
                //</ProtectedRoute>
              } 
            />
            <Route 
              path="/survey-report" 
              element={
                <ProtectedRoute>
                  <SurveyReport AuthContext={AuthContext} />
                </ProtectedRoute>
              } 
            />        
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <MakeConcertPage AuthContext={AuthContext} />
                </ProtectedRoute>
              } 
            /> 
            <Route 
              path="/concert" 
              element={
                <ProtectedRoute>
                  <Concert AuthContext={AuthContext} />
                </ProtectedRoute>
              } 
            /> 
            
            <Route 
              path="/survey" 
              element={
                  <Survey AuthContext={AuthContext} />
              } 
            />
            <Route
              path="/uerfheuryfhh/unsubscribe"
              element={<Unsubscribe />}
            />
          <Route 
              path="/book-writing" 
              element={
                <ProtectedRoute>
                  <BookWriting AuthContext={AuthContext} />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/crm" 
              element={
                <ProtectedRoute>
                  <Crm AuthContext={AuthContext} />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/logs-report" 
              element={
                <ProtectedRoute>
                  <LogsReport AuthContext={AuthContext} />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/emails" 
              element={
                <ProtectedRoute>
                  <Emails AuthContext={AuthContext} />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/create-campaign" 
              element={
                <ProtectedRoute>
                  <CreateCampaign AuthContext={AuthContext} />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/manage-songs" 
              element={
                <ProtectedRoute>
                  <ManageSongs AuthContext={AuthContext} />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/audio-analysis" 
              element={
                <ProtectedRoute>
                  <AiAudioAnalysis AuthContext={AuthContext} />
                </ProtectedRoute>
              } 
            />
           <Route 
              path="/home" 
              element={
                  <Home AuthContext={AuthContext} />
              } 
            /> 
            <Route 
              path="/doctest" 
              element={
                <ProtectedRoute>
                  <DocTests AuthContext={AuthContext} />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/about" 
              element={<AboutMe />} 
            />
            <Route 
              path="/how-it-works" 
              element={<HowItWorks />} 
            />
            <Route 
              path="/anxiety-what-if" 
              element={<AnxietyWhatIf />} 
            />
            <Route 
              path="/tell-me-how-you-feel" 
              element={
                <ProtectedRoute>
                  <TellMeHowYouFeel />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/qstash-test" 
              element={
                <ProtectedRoute>
                  <QStashTest />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/profile" 
              element={
                <ProtectedRoute>
                  <Profile AuthContext={AuthContext} />
                </ProtectedRoute>
              } 
            /> 
            <Route 
              path="/landing/webinar" 
              element={
                //<ProtectedRoute>
                  <Webinar />
                //</ProtectedRoute>
              } 
            />
          </Routes>

        </div>
      </BrowserRouter>
      <VisDiv rules={[hideFooter !== "true"]}>
        <Footer />
      </VisDiv>
   
    </div>
  );
}

export default App;
